import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { trackPromoDetailsClickAction } from '../../actions/analytics';
import { openPromoDetails } from '../../actions/promoDetails';
import { PromoItem } from '../../components/PromoItem';
import { selectPromoById } from '../../selectors/promos/promos';
import { TThunkDispatch } from '../../types/redux/thunk';

interface IPromoItemContainerProps {
  promoId: string;
}

export const PromoItemContainer = ({ promoId }: IPromoItemContainerProps) => {
  const promo = useSelector(selectPromoById(promoId));
  const dispatch: TThunkDispatch = useDispatch();

  const openPromoDetailsModal = React.useCallback(() => {
    dispatch(openPromoDetails(promoId));
    dispatch(trackPromoDetailsClickAction(promoId));
  }, [dispatch, promoId]);

  return <PromoItem promo={promo} onClick={openPromoDetailsModal} promoId={promoId} />;
};
